import { MandatoryAdministrativeFeeAppliedDto } from "./mandatoryAdministrativeFeeAppliedDto";
import { OptionalAdministrativeFeeAppliedDto } from "./optionalAdministrativeFeeAppliedDto";
import { SelectedProductsOrSubjectsRegistrationDto } from "./selectedProductsOrSubjectsRegistrationDto";
import { ShippingRatesAppliedDto } from "./shippingRatesAppliedDto";

export class LastOperationResultDto {

    listSelectedProductsOfRegistration!: SelectedProductsOrSubjectsRegistrationDto[];

    listShippingRatesApplied!: ShippingRatesAppliedDto[];

    listOptionalAdministrativeFeeApplied!: OptionalAdministrativeFeeAppliedDto[];

    listMandatoryAdministrativeFeeApplied!: MandatoryAdministrativeFeeAppliedDto[];

}